<template lang="html">

    <div class="quienes-somos">

        <section class="middle-intro row-start">

            <div class="container">

                <h1 class="title -intro">{{ $t('kitDigital.slider.title') }}</h1>
                <img :src="$t('kitDigital.slider.gif')" class="imagen-animacion" alt="slider kit digital">
            </div>

        </section>

        <section class="textos">

            <div class="container title-intro">
                <div class="container-logos" id="logosSubvencion">
                    <img src="/static/img/kit-digital-logos.png" class="imagen-logos container" alt="kit digital logos">
                </div>

                <h2 class="title kit">{{ $t('kitDigital.title') }}</h2>

            </div>

            <div class="first-text">

                <p><strong>El PROGRAMA KIT DIGITAL es un programa dirigido a pymes y autónomos, del Ministerio de
                        Asuntos Económicos y Transformación Digital para fomentar la transformación digital.</strong>
                </p>
                <div class="texto-kit">
                    <p><br>Se pretende que gracias a la tecnología las pymes y autónomos puedan evolucionar y mejorar su
                        negocio.
                        <br>¿Cómo? Con ayudas económicas que permitan acceder a un gran catálogo de soluciones digitales
                        y a agentes digitalizadores que ofrecen estos servicios. Solo se tiene que escoger las que mejor
                        se adapten a las necesidades de cada empresa.<br>El Kit Digital está dentro del programa de
                        ayudas del Plan de Recuperación para promover la digitalización de pymes y autónomos.
                        Subvenciones con un presupuesto de más de 3.000 millones de euros, financiado por la Unión
                        Europea a través de los fondos Next Generation EU dentro del Plan de Recuperación Transformación
                        y Resilencia.<br>El Kit Digital o bono digital (Digital Toolkit-DTK) nace para apoyar la
                        transformación digital de pymes y ayudarles en la búsqueda de soluciones digitales que aumenten
                        su nivel de madurez digital.
                        <br>La subvención por empresa puede llegar hasta 12.000 euros.
                    </p>
                </div>
                <!--<div class="logo-kit">
        <img src="/static/img/logos-kit.png" alt="Quienes somos 2">
        </div>-->
                <div class="contenedor-imagen animate row-start">
                    <img src="/static/img/kit2.png" alt="Quienes somos 2">
                </div>


            </div>
            <div class="texto-medio">
                <h2 class="title segmentos">¿A quién va dirigido el Kit Digital?</h2>
                <p>
                    El Kit Digital va dirigido inicialmente a pymes y autónomos de entre 1 y 49 trabajadores que cumplan
                    con los requisitos marcados por el Gobierno.<br>
                    Te presentamos abajo los 3 segmentos beneficiarios de las ayudas y el importe máximo del bono
                    correspondiente.
                </p>
                <div class="segmentos">
                    <div class="segmento-uno">
                        <h2>Segmento I</h2>
                        <p>Pequeñas empreas de entre 10 y menos de 50 empleados</p>
                        <p>12.000€</p>
                    </div>

                    <div class="segmento-uno">
                        <h2>Segmento II</h2>
                        <p>Pequeñas empreas o Microempresas de entre 3 y menos de 10 empleados</p>
                        <p>6.000€</p>
                    </div>

                    <div class="segmento-uno">
                        <h2>Segmento III</h2>
                        <p>Pequeñas empresas o Microempresas de entre 1 y menos de 3 empleados</p>
                        <p>2.000€</p>
                    </div>
                </div>
                <p class="texto-final">
                    Estas empresas <strong>podrán recibir hasta un máximo de 12.000€ en ayudas</strong> que tendrán que
                    utilizar en la digitalización de sus negocios eligiendo las soluciones digitalizadoras del Kit
                    Digital que mejor se adapten a las necesidades de sus negocios.
                    <br><br>
                    <strong>Para poder acceder al Kit Digital deberán hacerlo a través de uno o varios agentes
                        digitalizadores</strong> que podrán encontrar en la página Acelera pyme. Esto último es
                    importante porque las empresas digitalizadoras son las que acompañarán en todo el proceso de
                    solicitud a las empresas.
                </p>
            </div>
            <div class="second-text">

                <h2 class="areas">AREAS QUE CUBRE EL BONO DIGITAL</h2><br><br>

                <div class="logos-bono">
                    <div class="logo-individual">
                        <img src="/static/img/logo-bono1.png" alt="sitio web">
                        <p>Sitio web</p>
                    </div>

                    <div class="logo-individual">
                        <img src="/static/img/logo-bono2.png" alt="comercio electronico">
                        <p>Comercio Electrónico</p>
                    </div>

                    <div class="logo-individual">
                        <img src="/static/img/logo-bono3.png" alt="gestion de redes sociales">
                        <p>Gestión de Redes Sociales</p>
                    </div>

                    <div class="logo-individual">
                        <img src="/static/img/logo-bono4.png" alt="gestión de clientes y/o provedores">
                        <p>Gestión de clientes y/o provedores</p>
                    </div>

                    <div class="logo-individual">
                        <img src="/static/img/logo-bono5.png" alt="bussines intelligence y analítica">
                        <p>Business intelligence y analítica</p>
                    </div>

                    <div class="logo-individual">
                        <img src="/static/img/logo-bono6.png" alt="servicios y herramientas de oficina virtual">
                        <p>Servicios y herramientas de oficina virtual</p>
                    </div>

                    <div class="logo-individual">
                        <img src="/static/img/logo-bono7.png" alt="gestión de procesos">
                        <p>Gestión de procesos</p>
                    </div>

                    <div class="logo-individual">
                        <img src="/static/img/logo-bono8.png" alt="factura electrónica">
                        <p>Factura electrónica</p>
                    </div>

                    <div class="logo-individual">
                        <img src="/static/img/logo-bono9.png" alt="comuncaciones seguras">
                        <p>Comunicaciones seguras</p>
                    </div>

                    <div class="logo-individual">
                        <img src="/static/img/logo-bono10.png" alt="ciberseguridad">
                        <p>Ciberseguridad</p>
                    </div>
                </div>
                <!--  <div class="contenedor-imagen animate row-start">
        <img src="/static/img/kit1.png" alt="Quienes somos 2">
      </div>-->

                <!-- BOTON  <div class="contenedor-boton">
    <router-link class="btn-rounded-red waypoints" data="fadeInUp" :to="$t('enlaces.contacto')" v-html="$t('banner_contacto.contacta2')"></router-link>

    </div>-->


            </div>

            <div class="tabla-kit listado-kit">
                <h2>Importe bonificado de los servicios</h2>
                <div>
                    <ul>
                        <li>Sitio web:
                            <ul>
                                <li>Segmento III (0-2 empleados): 2.000€</li>
                                <li>Segmento II (3-9 empleados): 2.000€</li>
                                <li>Segmento I (10-49 empleados): 2.000€</li>
                            </ul>
                        </li>

                        <li>Comercio Electrónico:
                            <ul>
                                <li>Segmento III (0-2 empleados): 2.000€</li>
                                <li>Segmento II (3-9 empleados): 2.000€</li>
                                <li>Segmento I (10-49 empleados): 2.000€</li>
                            </ul>
                        </li>

                        <li>Gestión de redes sociales
                            <ul>
                                <li>Segmento III (0-2 empleados): 2.000€</li>
                                <li>Segmento II (3-9 empleados): 2.500€</li>
                                <li>Segmento I (10-49 empleados): 2.500€</li>
                            </ul>
                        </li>
                        <li>Gestión de clientes y/o proveedores:
                            <ul>
                                <li>Segmento III (0-2 empleados): 2.000€ (incluye 1 usuario)</li>
                                <li>Segmento II (3-9 empleados): 2.000€ (incluye 1 usuario)</li>
                                <li>Segmento I (10-49 empleados): 4.000€ (incluye 3 usuarios)</li>
                            </ul>
                        </li>
                        <li>BI y analítica
                            <ul>
                                <li>Segmento III (0-2 empleados): 1.500€ (incluye 1 usuario)</li>
                                <li>Segmento II (3-9 empleados): 2.000€ (incluye 1 usuario)</li>
                                <li>Segmento I (10-49 empleados): 4.000€ (incluye 3 usuarios)</li>
                            </ul>
                        </li>
                        <li>Gestión de procesos:
                            <ul>
                                <li>Segmento III (0-2 empleados): 500€ (incluye 1 usuario)</li>
                                <li>Segmento II (3-9 empleados): 2.000€ (incluye 3 usuarios)</li>
                                <li>Segmento I (10-49 empleados): 6.000€ (incluye 3 usuarios)</li>
                            </ul>
                        </li>
                        <li>Factura electrónica:
                            <ul>
                                <li>Segmento III (0-2 empleados): 500€ (incluye 1 usuario)</li>
                                <li>Segmento II (3-9 empleados): 1.000€ (incluye 1 usuario)</li>
                                <li>Segmento I (10-49 empleados): 1.000€ (incluye 3 usuarios)</li>
                            </ul>
                        </li>
                        <li>Servicios de oficina virtual:
                            <ul>
                                <li>Segmento III (0-2 empleados): 250€/usuario (incluye 2 usuarios)</li>
                                <li>Segmento II (3-9 empleados): 250€/usuario (incluye 9 usuarios)</li>
                                <li>Segmento I (10-49 empleados): 250€/usuario (incluye 48 usuarios)</li>
                            </ul>
                        </li>
                        <li>Comunicaciones seguras:
                            <ul>
                                <li>Segmento III (0-2 empleados): 125€/usuario (incluye 2 usuarios)</li>
                                <li>Segmento II (3-9 empleados): 125€/usuario (incluye 9 usuarios)</li>
                                <li>Segmento I (10-49 empleados): 125€/usuario (incluye 48 usuarios)</li>
                            </ul>
                        </li>
                        <li>Ciberseguridad:
                            <ul>
                                <li>Segmento III (0-2 empleados): 125€/usuario (incluye 2 usuarios)</li>
                                <li>Segmento II (3-9 empleados): 125€/usuario (incluye 9 usuarios)</li>
                                <li>Segmento I (10-49 empleados): 125€/usuario (incluye 48 usuarios)</li>
                            </ul>
                        </li>
                    </ul>

                </div>

            </div>
            <div class="tabla-kit">
                <div>
                    <h2>Importe bonificado de los servicios</h2>
                    <table>
                        <tr>
                            <td>Servicio de digitalización</td>
                            <td colspan="3">Importe bono</td>

                        </tr>
                        <tr>
                            <td></td>
                            <td>Segmento III<br>(0-2 empleados)</td>
                            <td>Segmento II<br>(3-9 empleados)</td>
                            <td>Segmento I<br>(10-49 empleados)</td>
                        </tr>
                        <tr>
                            <td>Sitio web</td>
                            <td>2.000€</td>
                            <td>2.000€</td>
                            <td>2.000€</td>
                        </tr>

                        <tr>
                            <td>Comercio Electrónico</td>
                            <td>2.000€</td>
                            <td>2.000€</td>
                            <td>2.000€</td>
                        </tr>

                        <tr>
                            <td>Gestión de redes sociales</td>
                            <td>2.000€</td>
                            <td>2.500€</td>
                            <td>2.500€</td>
                        </tr>

                        <tr>
                            <td>Gestión de clientes y/o proveedores</td>
                            <td>2.000€<br>(incluye 1 usuario)</td>
                            <td>2.000€<br>(incluye 1 usuario)</td>
                            <td>4.000€<br>(incluye 3 usuarios)</td>
                        </tr>

                        <tr>
                            <td>BI y analítica</td>
                            <td>1.500€<br>(incluye 1 usuario)</td>
                            <td>2.000€<br>(incluye 1 usuario)</td>
                            <td>4.000€<br>(incluye 3 usuarios)</td>
                        </tr>

                        <tr>
                            <td>Gestión de procesos</td>
                            <td>500€<br>(incluye 1 usuario)</td>
                            <td>2.000€<br>(incluye 3 usuarios)</td>
                            <td>6.000€<br>(incluye 3 usuarios)</td>
                        </tr>

                        <tr>
                            <td>Factura electrónica</td>
                            <td>500€<br>(incluye 1 usuario)</td>
                            <td>1.000€<br>(incluye 1 usuario)</td>
                            <td>1.000€<br>(incluye 3 usuarios)</td>
                        </tr>

                        <tr>
                            <td>Servicios de oficina virtual</td>
                            <td>250€ / usuario<br>(incluye 2 usuarios)</td>
                            <td>250€ / usuario<br>(incluye 9 usuario)</td>
                            <td>250€ / usuario<br>(incluye 48 usuarios)</td>
                        </tr>

                        <tr>
                            <td>Comunicaciones seguras</td>
                            <td>125€ / usuario<br>(incluye 2 usuarios)</td>
                            <td>125€ / usuario<br>(incluye 9 usuario)</td>
                            <td>125€ / usuario<br>(incluye 48 usuarios)</td>
                        </tr>

                        <tr>
                            <td>Ciberseguridad</td>
                            <td>125€ / usuario<br>(incluye 2 usuarios)</td>
                            <td>125€ / usuario<br>(incluye 9 usuario)</td>
                            <td>125€ / usuario<br>(incluye 48 usuarios)</td>
                        </tr>
                    </table>
                </div>
            </div>

        </section>



        <!------------------------------------>
        <section style="margin-top:60px; text-align:left">
            <div class="features-arriba container">
                <div class="texto">
                    <h2 class="title -intro features">
                        Soluciones de digitalización cubiertas por Innopulse dentro del ámbito del programa Kit Digital
                    </h2>
                    <p style="margin-top:20px"><span class="descargar"><img src="/static/img/flechas.svg"
                                alt="flecha"><a href="/static/data/pdf/iformalia_soluciones.pdf" target="_blank"
                                download>Descargar presentación de soluciones de digitalización</a></span></p>
                </div>
                <div :class="[
                    showFeatureAll
                        ? 'boton-features-div'
                        : 'boton-features-div inactive'
                ]">
                    <template v-if="showFeatureAll">
                        <p class="title -intro features contraer">Contraer todo</p>
                    </template>
                    <template v-else>
                        <p class="title -intro features contraer">Expandir todo</p>
                    </template>
                    <div class="boton-azul" @click="toggleFeature">
                        <div class="boton-circulo"></div>
                    </div>
                </div>
            </div>
            <div class="producto-desc feature row-between">
                <div :dataFeature4="dataFeature4" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
                    <div class="cabecera-feature" @click="toggleThisFeature4">
                        <div class="container">
                            <h3 class="title feature">Iformalia CRM con Inteligencia Artificial: Gestión de Clientes
                                Avanzada</h3>
                            <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
                        </div>
                    </div>
                    <div class="contenido-features container">
                        <p>
                            <strong>CATEGORÍA: </strong>Gestión de clientes
                            <br> <strong>NOMBRE DE LA SOLUCIÓN: </strong>Iformalia CRM con IA
                            <br> <strong>DESCRIPCIÓN: </strong>
                            El módulo <strong>Iformalia CRM con Inteligencia Artificial</strong> lleva la gestión de
                            clientes a un nuevo nivel al integrar tecnologías avanzadas de <strong>IA y análisis de
                                datos</strong>. Este sistema no solo almacena la información básica de los clientes
                            (nombre, dirección, teléfono), sino que también
                            <strong>analiza</strong> y <strong>predice patrones de comportamiento</strong> y
                            <strong>optimiza las interacciones comerciales</strong>.<br>
                            A través del uso de <strong>IA</strong>, el sistema puede hacer predicciones precisas sobre
                            las preferencias y necesidades de los clientes, anticipando acciones de ventas
                            personalizadas y estrategias de marketing altamente efectivas. El CRM se integra con
                            <strong>asistentes virtuales</strong> que pueden gestionar tareas repetitivas como el
                            seguimiento de emails, programación de citas o incluso la generación automática de informes
                            sobre el estado de las relaciones con los clientes.<br>
                            Además, el sistema se conecta de forma segura desde <strong>cualquier dispositivo</strong>,
                            permitiendo al equipo comercial gestionar y actualizar la información de los clientes de
                            manera dinámica y en tiempo real. Las conversaciones y puntos de contacto son
                            <strong>personalizados, relevantes y basados en datos actualizados</strong>, lo que permite
                            mejorar la <strong>satisfacción y fidelización de los clientes</strong>.<br>
                            <strong>Ventajas destacadas:</strong><br>
                        <ul>
                            <li><strong> Automatización de tareas repetitivas.</strong></li>
                            <li><strong> Predicciones y recomendaciones personalizadas.</strong></li>
                            <li><strong> Optimización de la gestión de leads.</strong></li>
                            <li><strong> Acceso a datos en tiempo real.</strong></li>
                            <li><strong> Integración con otras plataformas y datos.</strong></li>

                        </ul>

                        </p>
                        <p class="precios-soluciones">PRECIOS: 10.000€ a 25.000€ <br><br>
                        </p>

                    </div>
                </div>
            </div>
            <div class="producto-desc feature row-between">
                <div :dataFeature5="dataFeature5" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
                    <div class="cabecera-feature" @click="toggleThisFeature5">
                        <div class="container">
                            <h3 class="title feature">Iformalia ERP con Inteligencia Artificial: Gestión Integral de
                                Procesos</h3>
                            <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
                        </div>
                    </div>
                    <div class="contenido-features container">
                        <p>
                            <strong>CATEGORÍA: </strong>Gestión de procesos
                            <br> <strong>NOMBRE DE LA SOLUCIÓN: </strong>Iformalia ERP con IA
                            <br> <strong>DESCRIPCIÓN: </strong>
                            El módulo <strong>Iformalia ERP con Inteligencia Artificial</strong> está diseñado
                            para
                            optimizar la
                            gestión de
                            procesos empresariales, especialmente enfocado en empresas de formación, pero
                            completamente
                            adaptable a otros sectores. Este sistema de gestión integra la <strong>IA para
                                mejorar la
                                eficiencia
                                operativa y optimizar la toma de decisiones</strong> en diversas áreas
                            funcionales, desde la
                            administración hasta la logística.<br>
                            El <strong>Iformalia ERP con IA</strong> facilita la gestión de la actividad
                            formativa,
                            incluyendo la automatización de la creación de documentación, la generación de
                            modelos de
                            impresos, la gestión de ficheros XML y el control de los objetivos, seguimiento
                            económico y
                            plazos de las programaciones formativas. La <strong>IA</strong> mejora los procesos
                            al realizar
                            predicciones y análisis de datos en tiempo real, permitiendo a las empresas
                            adaptarse
                            rápidamente a cambios en el entorno o las demandas del mercado.<br>
                            En áreas clave como <strong>Administración, Proyectos, Comercial y Marketing,
                                Económico-Financiera, Inventarios, Gestión de Formación, RRHH, Logística,
                                Formación
                                eLearning y Certificados de Profesionalidad online</strong>, la integración de
                            IA transforma
                            tareas complejas y repetitivas en acciones automáticas y optimizadas, ahorrando
                            tiempo y
                            recursos, además de ofrecer <strong>informes y análisis</strong> predictivos para
                            mejorar la
                            toma de decisiones estratégicas.<br>
                            <strong>Ventajas destacadas:</strong><br>
                        <ul>
                            <li><strong>Automatización de procesos administrativos.</strong></li>
                            <li><strong>Optimización de la gestión de procesos.</strong></li>
                            <li><strong>Mejora en la gestión económica-financiera.</strong></li>
                            <li><strong>Gestión inteligente de inventarios y compras.</strong></li>
                            <li><strong>Optimización del área de formación.</strong></li>

                        </ul>

                        </p>
                        <p class="precios-soluciones">PRECIOS: 10.000€ a 20.000€ <br><br>
                        </p>

                    </div>
                </div>
            </div>
            <div class="producto-desc feature row-between">
                <div :dataFeature6="dataFeature6" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
                    <div class="cabecera-feature" @click="toggleThisFeature6">
                        <div class="container">
                            <h3 class="title feature">Iformalia Reporting Avanzado y Business Intelligence con
                                Inteligencia
                                Artificial</h3>
                            <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
                        </div>
                    </div>
                    <div class="contenido-features container">
                        <p>
                            <strong>CATEGORÍA: </strong>Business Intelligence y Analítica
                            <br> <strong>NOMBRE DE LA SOLUCIÓN: </strong>Iformalia Reporting Avanzado y BI con IA

                            <br> <strong>DESCRIPCIÓN: </strong>
                            El módulo <strong>Iformalia Reporting Avanzado y Business Intelligence con Inteligencia
                                Artificial</strong> lleva la analítica empresarial a un nuevo nivel, integrando
                            tecnologías de
                            <strong>IA</strong> para <strong>optimizar el análisis de datos</strong> y la
                            <strong>visualización</strong> de los informes y dashboards generados a partir de Power BI.
                            Este sistema
                            conecta automáticamente los datos provenientes de la base de datos (BBDD), que se autogenera
                            y actualiza
                            constantemente con cálculos, dimensiones, relaciones y contadores, para ofrecer
                            <strong>informes de alto
                                valor y KPIs</strong> esenciales para las decisiones estratégicas.<br>
                            <strong>Iformalia Reporting Avanzado y BI con IA</strong> utiliza <strong>Machine
                                Learning</strong> para
                            proporcionar insights más precisos y predictivos sobre la evolución de las actividades
                            empresariales, el
                            seguimiento presupuestario, el análisis de calidad, el absentismo laboral y más. Esta
                            integración con IA
                            no solo facilita la creación de informes personalizados, sino que también mejora la
                            capacidad de
                            <strong>predecir tendencias y detectar anomalías</strong>, permitiendo una toma de
                            decisiones más ágil y
                            fundamentada.<br>
                            La <strong>IA</strong> optimiza la generación automática de informes e indicadores clave
                            (KPIs), que se
                            actualizan constantemente en la base de datos de intercambio y alimentan Power BI sin
                            necesidad de
                            integración o procesamiento manual de datos. La solución también permite a los usuarios sin
                            conocimientos técnicos crear y personalizar sus propios <strong>dashboards</strong>,
                            reportes y gráficos
                            interactivos, gracias a la interfaz simple y amigable de Power BI.<br>
                            <strong>Ventajas destacadas:</strong><br>
                        <ul>
                            <li><strong>Automatización y actualización constante de los datos.</strong></li>
                            <li><strong>Análisis predictivo y detección de patrones.</strong></li>
                            <li><strong>Visualización interactiva y personalizable.</strong></li>
                            <li><strong>Mejora continua de los KPIs.</strong></li>
                            <li><strong>Optimización del tiempo y recursos.</strong></li>


                        </ul>

                        </p>
                        <p class="precios-soluciones">PRECIOS: 3.000€ a 10.000€ <br><br>
                        </p>

                    </div>
                </div>
            </div>
            <div class="producto-desc feature row-between">
                <div :dataFeature1="dataFeature1" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
                    <div class="cabecera-feature" @click="toggleThisFeature1">
                        <div class="container">
                            <h3 class="title feature">Iformalia CRM: Gestión de clientes</h3>
                            <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
                        </div>
                    </div>
                    <div class="contenido-features container">
                        <p>
                            <strong>CATEGORÍA: </strong>Gestión de clientes
                            <br> <strong>NOMBRE DE LA SOLUCIÓN: </strong>Iformalia CRM
                            <br> <strong>DESCRIPCIÓN: </strong>El módulo CRM de iformalia se refiere alconjunto de
                            prácticas,
                            estrategias de negocio y tecnologías enfocadas en la relación con el cliente.<br> Nuestro
                            módulo CRM
                            almacena información de clientes actuales
                            y potenciales -nombre, dirección, teléfono, etc-, y sus actividades y puntos de contacto con
                            la empresa,
                            incluyendo visitas a sitios, llamadas telefónicas, e-mails, entre otras interacciones. No
                            obstante, la
                            plataforma no es solo una lista
                            de contactos elaborada: ella reúne e integra datos valiosos para preparar y actualizar al
                            equipo
                            comercial con información personal de los clientes, historial y preferencias de compras.
                            <br>El sistema nos permitirá rastrear activamente y administrar la información de los
                            clientes,
                            conectando al equipo desde cualquier dispositivo. Simplificaremos tareas repetitivas para
                            poder hacer un
                            acompañamiento de leads más efectivo.
                            <br>Encontraremos más leads, cerraremos más negocios, conservaremos más clientes...,en
                            definitiva,
                            creceremos notablemente de manera organizada. Y es que las conversaciones son siempre
                            personales,
                            relevantes y actualizadas, generando un
                            importante aumento en la satisfacción del cliente.
                        </p>
                        <p class="precios-soluciones">PRECIOS: de 5.000€ a 10.000€<br><br>
                            <span class="descargar"><img src="/static/img/flechas.svg" alt="flecha"><a
                                    href="/static/data/pdf/CRM_Gestión_clientes.pdf" target="_blank" download>Descargar
                                    presentación
                                    CRM Gestión de cliente</a></span>
                        </p>

                    </div>
                </div>




                <div class="producto-desc feature row-between">
                    <div :dataFeature2="dataFeature2" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
                        <div class="cabecera-feature" @click="toggleThisFeature2">
                            <div class="container">
                                <h3 class="title feature">Iformalia Reporting avanzado y BI</h3>
                                <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
                            </div>
                        </div>
                        <div class="contenido-features container">
                            <p>
                                <strong>CATEGORÍA: </strong>Business Intelligence y Analítica
                                <br> <strong>NOMBRE DE LA SOLUCIÓN: </strong>Iformalia Reporting abanzado y BI
                                <br> <strong>DESCRIPCIÓN: </strong>Iformalia dispone de un módulo avanzado de Reporting
                                y diseño de
                                Dashboards basado en PowerBI, interconectando la información desde una BBDD de datos
                                preparados
                                (cálculos, dimensiones, relaciones,
                                contadores, etc...) que se autogenerará constantemente, para ofrecer los indicadores
                                diseñados para
                                el seguimiento de cualquier capa de negocio (Ejecución del presupuesto, Evolución de la
                                actividad,
                                test de valoración de calidad, absentismo
                                laboral, informes económicos, etc...)
                                <br> Power BI es un servicio de análisis empresarial de Microsoft, su objetivo es
                                proporcionar
                                visualizaciones interactivas y capacidades de Business Intelligence (BI) con una
                                interfaz lo
                                suficientemente simple como para que los usuarios
                                gestores sin conocimientos técnicos o informáticos creen sus propios informes y paneles
                                o
                                dashboards.
                                <br> Desde Iformalia se posibilita la definición de informes e indicadores clave (KPIs),
                                que
                                autogenerarán en la BBDD de intercambio periódicamente, sirviendo como entrada
                                automática a PowerBi,
                                para la definición libre de limitados
                                informes, gráficos, paneles, etc...sin necesidad de integración o correspondencia de
                                datos.
                            </p>
                            <p class="precios-soluciones">PRECIOS: de 2.500€ a 7.500€<br><br>
                                <span class="descargar"><img src="/static/img/flechas.svg" alt="flecha"><a
                                        href="/static/data/pdf/Reporting_y_BI.pdf" target="_blank" download>Descargar
                                        presentación
                                        Reporting avanzado y BI</a></span>
                            </p>

                        </div>
                    </div>


                    <div class="producto-desc feature row-between">
                        <div :dataFeature3="dataFeature3" :class="[showFeatureAll ? 'feature' : 'feature inactive']">
                            <div class="cabecera-feature" @click="toggleThisFeature3">
                                <div class="container">
                                    <h3 class="title feature">Iformalia ERP</h3>
                                    <img src="/static/img/boton-cerrar.png" alt="boton cerrar" />
                                </div>
                            </div>
                            <div class="contenido-features container">
                                <p>
                                    <strong>CATEGORÍA: </strong>Gestión de procesos
                                    <br> <strong>NOMBRE DE LA SOLUCIÓN: </strong>Iformalia ERP
                                    <br> <strong>DESCRIPCIÓN: </strong> Se trata del sistema de gestión para empresas de
                                    formación
                                    en particular, y casi para cualquier empresa en general.<br>
                                <ul>
                                    <li>Permite realizar la operativa de todas las actividades requeridas en el día a
                                        día de la
                                        empresa</li>
                                    <li>Para las empresas de formación, facilita la gestión de su negocio (actividad
                                        formativa):
                                        documentación, modelos de impreso, ficheros XML, control de objetivos,
                                        seguimiento
                                        económico, plazos y restricciones de las Programaciones.</li>
                                    <li>Proporciona una herramienta fundamental para las áreas de :
                                        <ul>
                                            <li>Administrativa</li>
                                            <li>Proyectos</li>
                                            <li>Comercial y Marketing</li>
                                            <li>Económico financiera</li>
                                            <li>Inventario</li>
                                            <li>Gestión de Formación, Orientación y RRHH</li>
                                            <li>Logística</li>
                                            <li>Formación elearning y Certificados de Profesionalidad online</li>
                                            <li>Compras y pagos</li>
                                        </ul>
                                    </li>
                                </ul>

                                </p>
                                <p class="precios-soluciones">PRECIOS: de 5.000€ a 10.000€<br><br>
                                    <span class="descargar"><img src="/static/img/flechas.svg" alt="flecha"><a
                                            href="/static/data/pdf/iformalia_ERP.pdf" target="_blank" download>Descargar
                                            presentación ERP</a></span>
                                </p>

                            </div>
                        </div>
                    </div>

                </div>
            </div>


        </section>


        <div class="bono-digital">
            <div class="container">

                <h3>Requisitos para conseguir el bono digital</h3>
                <h4>Aquí enumeramos los requisitos para solicitar el bono digital o ayuda para las Pymes:</h4>
                <ul>
                    <li><strong>Ser una pequeña empresa, microempresa o autónomo (entre 1 y 49 trabajadores).</strong>
                    </li>
                    <li><strong>Estar registrado en Acelera pyme y realizar el test digital a tu empresa (lo explicamos
                            en
                            detalle más adelante).</strong></li>
                    <li><strong>Una vez concebida la ayuda, tendrás 6 meses para gastarla en hasta 5 servicios de 1 año
                            de
                            duración.</strong></li>
                    <li><strong>La subvención cubre hasta el 100% del coste de los servicios.</strong></li>
                    <li><strong>La subvención será inferior al coste mínimo de implantar el paquete.</strong></li>
                    <li><strong>El bono será de un máximo de 12.000€.</strong></li>
                    <li><strong>Cumplir los límites financieros y efectivos que definen las categorías de
                            empresas.</strong>
                    </li>
                    <li><strong>Estar en situación de alta y tener la antigüedad mínima que se establece por
                            convocatoria.</strong></li>
                    <li><strong>Estar al corriente de las obligaciones tributarias y frente a la Seguridad
                            Social.</strong></li>
                    <li><strong>No estar sujeta a una orden de recuperación pendiente de la Comisión Europea que haya
                            declarado
                            una ayuda ilegal e incompatible con el mercado común.</strong></li>
                    <li><strong>No incurrir en ninguna de las prohibiciones pevistas en el artículo 13.2 de la Ley
                            38/2003, de
                            17 de noviembre, General de Subvenciones</strong></li>
                    <li><strong>No superar el límite de ayudas minimis (de pequeña cuantía).</strong></li>
                </ul>
            </div>
        </div>


        <div class="conseguir-bono">
            <h3>Cómo conseguir el bono digital</h3>

            <div>
                <div class="bono-uno">
                    <h3>Cómo solicitar tu bono digital</h3>
                    <div class="pasos"><span class="numero">01</span>
                        <p><span style="color:#3374b0;font-weight: bold;">Regístrate</span> en el <strong
                                style="color: #41566d;">área privada</strong> de <strong style="color: #41566d;">Acelera
                                Pyme</strong></p>
                    </div>
                    <div class="pasos"><span class="numero">02</span>
                        <p style="margin-top:10px"><span style="color:#3374b0;font-weight: bold;">Consulta</span> la
                            información
                            disponible de las <strong style="color: #41566d;">soluciones de digitalización</strong> que
                            pondrá a
                            tu disposición el programa Kit Digital.</p>
                    </div>
                    <div class="pasos"><span class="numero">03</span>
                        <p style="margin-top:10px">Próximamente podrás acceder a los trámites para solicitar tu <strong
                                style="color: #41566d;">bono Kit Digital.</strong></p>
                    </div>




                </div>


                <div class="bono-dos">
                    <h3>Cómo emplear tu bono digital</h3>
                    <div class="pasos"><span class="numero">01</span>
                        <p>Próximamente podrás <strong style="color: #41566d;">acceder</strong> al catálogo de Agendes
                            Digitalizadores.</p>
                    </div>
                    <div class="pasos"><span class="numero">02</span>
                        <p><span style="color:#3374b0;font-weight: bold;">Ponte en contacto</span> con el Agente
                            seleccionado.
                        </p>
                    </div>


                </div>
            </div>

        </div>

    </div>

</template>

<script lang="js">
    import ProductosList from '@/components/parts/productos-list';

    export default {
        name: 'kit-digital',
        props: [],
        mounted() {
            if (window.location.search) {
                $("html,body").animate({
                    scrollTop: $('html').find($('#' + window.location.search.substring(1))).offset().top + 100
                }, 1000)
            }
            $(window).scroll(function (event) {
                let altura = $(window).scrollTop();
                // console.log(altura);
                if (altura > 450 && !$(".title-intro .container-logos").hasClass('fixedLogos')) {
                    $(".title-intro .container-logos").addClass('fixedLogos');
                } else if (altura <= 450 && $(".title-intro .container-logos").hasClass('fixedLogos')) {
                    $(".title-intro .container-logos").removeClass('fixedLogos');
                }
            });


        },
        data() {
            return {
                showFeatureAll: true,
                dataFeature1: true,
                dataFeature2: true,
                dataFeature3: true,
                dataFeature4: true,
                dataFeature5: true,
                dataFeature6: true

            }
        },
        methods: {

            toggleContent: function () {
                event.target.parentNode.parentNode.classList.toggle("active")
                event.target.parentNode.parentNode.querySelector('.box-contenido').classList.toggle("active")
            },
            CloseContent: function () {
                event.target.parentNode.parentNode.parentNode.querySelector('.box-contenido').classList.remove("active")
            },
            toggleFeature: function () {
                this.showFeatureAll = !this.showFeatureAll;
            },

            toggleThisFeature1: function () {
                $('.feature[datafeature1="true"]').toggleClass('inactive')

            },
            toggleThisFeature2: function () {
                $('.feature[datafeature2="true"]').toggleClass('inactive')

            },
            toggleThisFeature3: function () {
                $('.feature[datafeature3="true"]').toggleClass('inactive')

            },
            toggleThisFeature4: function () {
                $('.feature[datafeature4="true"]').toggleClass('inactive')

            },
            toggleThisFeature5: function () {
                $('.feature[datafeature5="true"]').toggleClass('inactive')

            },
            toggleThisFeature6: function () {
                $('.feature[datafeature6="true"]').toggleClass('inactive')

            },

        },
        components: {
            'productos-list': ProductosList
        }

    }
</script>

<style scoped>
    li ul {
        margin-left: 30px
    }

    li {
        list-style-type: disc;
        list-style-position: inside
    }

    .features-arriba {
        display: flex;
        justify-content: space-between;
    }

    .descargar {
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.56;
        letter-spacing: normal;
        color: #41566d;
    }

    .descargar a {
        margin-left: 31px
    }

    .precios-soluciones {
        font-size: 24px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: normal;
        color: #51ac34;
    }

    .tabla-kit {
        background: #3374b0;
        color: white;
        padding-bottom: 50px
    }

    .tabla-kit div {
        width: 100%;
        max-width: 1240px;
        margin: 0 auto
    }

    .tabla-kit h2 {
        font-size: 36px;
        padding-top: 80px;
    }

    table {
        font-size: 18px;
        border: 1px solid white;
        width: 100%;
        border-collapse: collapse;
        margin-top: 50px;
    }

    table td {
        border: 1px solid white;
        padding: 25px
    }

    table td:nth-child(1) {
        text-align: left;
    }

    .container.title-intro {
        margin-top: 130px
    }

    .container.title-intro .container-logo {
        position: initial;
        z-index: 0;
    }

    .container.title-intro .container-logos.fixedLogos {
        position: fixed;
        top: 25px;
        z-index: 5;
        background: #e1eaf2;
        width: 100%;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.2s;
    }

    .container.title-intro .container-logos.fixedLogos img {
        margin: 0 auto !important;
        transform: scale(0.8);
        transition: all 0.2s;
    }

    .texto-final {
        text-align: left !important;
    }

    .title.segmentos {
        font-size: 36px;
        color: #3374b0
    }

    .texto-medio p {
        text-align: center;
    }

    .logo-kit img {
        width: 50%;
        margin-top: 10px;
    }

    .logo-kit {
        display: flex;
        justify-content: center;
    }

    .middle-intro .title.-intro {
        color: #41566d;
    }

    .title-intro {
        text-align: left;
        padding: 20px 40px 0px 0px;
    }

    .title-intro .title {
        max-width: 480px;
        color: #3374b0;
    }

    .first-text {
        width: 100%;
        text-align: left;
        background-color: #f4f4f4;
        color: #1d1d1d;
        position: relative;
        margin-top: 100px;
        padding: 50px 0;
    }

    .first-text p {
        width: 100%;
        max-width: 1240px;
        margin: 0 auto;
        padding-top: 50px;
        padding-right: 625px;
        padding-left: 0px;
    }

    .texto-kit p {
        margin-top: 62px;
        padding: 0px;
    }

    p {
        margin-bottom: 20px;
        font-size: 18px;
        line-height: 28px;
        font-weight: 300;
    }

    .title.segmentos+p {
        margin-bottom: 80px;
    }

    .first-text p:last-of-type {
        margin-bottom: 0;
    }

    .first-text p strong {
        font-weight: 700;
    }

    .first-text .contenedor-imagen {
        position: absolute;
        width: 45%;
        background: #41566d;
        right: 0;
        top: -380px;
    }

    .first-text .contenedor-imagen::before {
        background: #41566d;
    }

    .first-text .contenedor-imagen img {
        max-width: 580px;
    }

    .texto-medio {
        margin: 130px auto;
        display: flex;
        flex-direction: column;
        text-align: left;
        width: 100%;
        max-width: 1240px;
    }

    .contenedor-boton {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .contenedor-boton a {
        background: #3374AF;
        color: white;
        border: 1px solid white;
        margin-top: 30px
    }

    .second-text h1 {
        width: 100%;
        max-width: 1240px;
        margin: 0 auto;
        padding: 0 20px;
        text-align: center;
    }

    .second-text p {
        width: 100%;
        max-width: 1240px;
        margin: 0 auto;
        padding: 0 20px;
        text-align: center;
    }

    .second-text {
        background-color: rgba(51, 116, 176, 0.2);
        display: inline-block;
        text-align: left;
        color: #3374b0;
        width: 100%;
        position: relative;
        padding: 50px 0;
        padding-bottom: 202px
    }

    .imagen-animacion {
        top: -215px
    }

    .second-text+.contenedor-boton {
        padding: 100px 0;
        max-width: 64%;
        text-align: center;
    }

    .second-text .contenedor-imagen {
        position: absolute;
        width: 36%;
        left: 0;
        top: -100px;
    }

    .second-text .contenedor-imagen {
        transform: translateX(110%);
    }

    .second-text .contenedor-imagen.active {
        transform: translateX(0%);
    }

    .second-text .contenedor-imagen::before {
        background: #41566d;
    }

    .second-text .contenedor-imagen.active::before {
        transform: translateX(110%);
    }

    .second-text .contenedor-imagen img {
        max-width: 600px;
    }

    .segmentos h2 {
        text-align: left !important;
        width: 100%;
        font-family: Roboto;
        font-size: 24px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: normal;
        color: #41566d;
    }

    .logo-individual p {
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #3374b0;
    }

    @media screen and (max-width: 1000px) {
        p {
            margin-bottom: 20px;
        }

        .first-text .contenedor-imagen {
            display: none;
        }

        .first-text {
            padding: 50px 7%;
            margin-top: 0;
        }

        .middle-intro {
            margin-bottom: 0;
        }
    }

    @media screen and (max-width: 850px) {
        .first-text p {
            padding-right: 0px;
        }

        .logo-individual {
            width: 50%;
        }

        .segmentos {
            justify-content: center;
        }

        .segmento-uno {
            margin-bottom: 50px
        }

        .title-intro .title {
            max-width: 800px;
        }

        .tabla-kit {
            padding: 40px 20px;
            margin: 0 auto
        }

        .texto-medio {
            padding: 40px 20px;
            margin: 0 auto
        }

        .bono-digital {
            padding: 40px 20px;
            margin: 0 auto
        }

        .conseguir-bono h3 {
            margin-top: 20px
        }

        .container.title-intro {
            margin-top: 0px;
            padding: 20px 40px
        }

        .container.title-intro .container-logos.fixedLogos {
            position: fixed;
            top: 55px;
            padding-bottom: 5px;
        }

        .container.title-intro .container-logos.fixedLogos img {
            transform: scale(1);
        }
    }

    @media screen and (max-width: 650px) {
        .tabla-kit {
            display: none
        }

        .tabla-kit.listado-kit {
            display: block
        }
    }

    @media screen and (max-width: 600px) {
        .segmento-uno {
            width: 100%
        }

        .second-text,
        .first-text,
        .title-intro {
            padding: 50px 15px;
        }

        .first-text p {
            padding-right: 0px;
        }

        .logo-individual {
            width: 50%;
        }

        .second-text .contenedor-imagen {
            display: none;
        }

        .second-text+.contenedor-boton {
            padding: 50px 0;
            max-width: 100%;
        }

        .second-text p {
            width: 100%;
            max-width: 1240px;
            margin: 50px auto;
            padding: 0 20px;
        }

        .first-text p {
            width: 100%;
            max-width: 1240px;
            margin: 50px auto;
            padding: 0 20px;
        }

        .title.kit {
            margin-top: 0px !important
        }

        .imagen-logos {
            margin-top: 0px
        }

        .segmento-uno h2 {
            text-align: center !important;
        }

        .segmento-uno p {
            text-align: center !important;
        }

        .bono-uno {
            width: 100%;
        }

        .bono-dos {
            width: 100%;
            margin-top: 0px
        }

        .conseguir-bono div {
            justify-content: space-between;
            flex-direction: column;
            flex-wrap: wrap;
        }

        .pasos {
            text-align: center;
        }
    }

    @media screen and (max-width: 380px) {
        .title.kit {
            margin-top: 0px !important
        }

        .imagen-logos {
            margin-top: 0px
        }

        .segmento-uno h2 {
            text-align: center !important;
        }

        .segmento-uno p {
            text-align: center !important;
        }

        .bono-uno {
            width: 100%;
        }

        .bono-dos {
            width: 100%;
            margin-top: 0px
        }

        .conseguir-bono div {
            justify-content: space-between;
            flex-direction: column;
            flex-wrap: wrap;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/kit-digital.vue